module.exports = __webpack_public_path__ + "img/7be9c9a.jpg";